export default __webpack_public_path__ + "static/media/JP2-1.ea57d7d1.jpg";